
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.08 16c1.425-2.31.387-5.191-3.298-6.602l.216 2.514c-1.19.67-1.624 2.597-.92 4.053C2.097 14.708.427 9.008 3.661 4.88c0 0 .589 2.377 1.998 2.565C4.641 4.106 6.821.808 10.817 0l-.672 2.434c1.599.695 2.578 2.981 2.489 4.627 1.09-.162 1.382-2.243 1.382-2.243 3.34 3.12 2.528 9.9-2.935 11.182z","fill":"#E13131"}})])
          )
        }
      }
    